export enum ImagePosition {
    Left = 0,
    Center = 1,
    Right = 2,
}

export const IMAGE_POSITION_OPTIONS: Record<ImagePosition, string> = {
    [ImagePosition.Left]: "-left",
    [ImagePosition.Center]: "-center",
    [ImagePosition.Right]: "-right",
};
